import {useTranslation} from "react-i18next";

export const Footer = () => {
    const {t} = useTranslation();
    return (
      <footer>
             <p>© 2024 Infospace Holdings LLC, A System1 Company. All Rights Reserved.</p>
              <ul>
                  <li>
                      <a target='_blank' href="https://system1.com/terms/privacy-policy" rel="noreferrer">
                          {t('Privacy Policy')}
                      </a>
                  </li>

                  <li>
                      <a target='_blank' href="https://system1.com/terms/terms-of-use" rel="noreferrer">
                          {t('Terms of Use')}
                      </a>
                  </li>

                  <li>
                      <a target='_blank' href="https://system1.com/" rel="noreferrer">
                          {t('Contact')}
                      </a>
                  </li>
              </ul>
      </footer>
    );
}
